export default {
  title: 'Connectez-vous à votre propre adresse',
  description:
    'Cette adresse appartient à un partenaire dont votre compte ne fait pas partie. Pour protéger votre compte, connectez-vous là où vous le faites habituellement : votre e-mail et votre mot de passe y fonctionnent.',
  continue: 'Continuer vers {{host}}',
  password_changed: 'Votre mot de passe a été modifié.',
};
